import { render, staticRenderFns } from "./MateriaisEdit.vue?vue&type=template&id=0f0ecc79&scoped=true"
import script from "./MateriaisEdit.vue?vue&type=script&lang=js"
export * from "./MateriaisEdit.vue?vue&type=script&lang=js"
import style0 from "./MateriaisEdit.vue?vue&type=style&index=0&id=0f0ecc79&prod&lang=css"
import style1 from "./MateriaisEdit.vue?vue&type=style&index=1&id=0f0ecc79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ecc79",
  null
  
)

export default component.exports